"use client";

import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  // If running on the same domain, no need to specify baseURL
});

// Export specific methods for easier imports
export const { signIn, signOut, signUp, useSession } = authClient; 